import router from './router'

// 未登录状态下可以访问的路由
const whiteList = ['/login','/home','/hall','/guide']

router.beforeEach(async (to, from, next) => {
  const hasToken = localStorage.getItem('sys_token')
  if (hasToken) {
    if (to.path === '/login') {
      next({ path: '/home' })
    } else {
      next()
    }
  } else {
    if (whiteList.includes(to.path)) {
      next()
    } else {
      next(`/login?redirect=${to.path}`)
    }
  }
})
